import LegalLayout from "@/components/LegalLayout";
import useSiteContent from "@/hooks/useSiteContent";
import WhatsAppCta from "@/components/WhatsAppCta";

const TOC = [
    { id: "entity", label: "Registered entity" },
    { id: "channels", label: "Contact channels" },
    { id: "grievance", label: "Grievance / disputes" },
    { id: "office-hours", label: "Office hours" },
];

const CONTACT_DEFAULTS = {
    contact_hero: {
        eyebrow: "Contact Doctor Digital Identity Platform",
        title: "Contact Us",
        intro: "We're happy to help with any questions about your account, package, refund request, or legal / compliance matters.",
    },
};

export default function Contact() {
    const { content } = useSiteContent(CONTACT_DEFAULTS);
    const hero = content.contact_hero || CONTACT_DEFAULTS.contact_hero;
    return (
        <LegalLayout title={hero.title} updated="February 2026" toc={TOC}>
            <p data-testid="contact-intro">{hero.intro}</p>
            <div className="not-prose my-4">
                <WhatsAppCta variant="inline" label="Chat on WhatsApp — usually replies within an hour" />
            </div>

            <h2 id="entity">Registered entity</h2>
            <div className="not-prose bg-white border border-[#123B5D]/10 rounded-xl p-5 my-4">
                <div className="text-xs uppercase tracking-widest text-[#0F766E] font-semibold">Company</div>
                <div className="text-lg font-bold text-[#123B5D] mt-1" data-testid="legal-entity-name">
                    HUMANITYFIRST SOFTWARE TECHNOLOGY PRIVATE LIMITED
                </div>
                <div className="text-sm text-[#17212B]/70 mt-1">
                    Trading brand: Doctor Digital Identity Platform (Doctor Digital ID)
                </div>
                <div className="grid sm:grid-cols-2 gap-4 mt-4 text-sm">
                    <div>
                        <div className="text-xs uppercase text-[#17212B]/50 font-semibold tracking-wider">Registered address</div>
                        <div className="mt-1 text-[#17212B]" data-testid="legal-registered-address">
                            A-803 Palatial Height,<br />
                            Chandivali Farm Road,<br />
                            Andheri, Mumbai,<br />
                            Maharashtra 400072, India
                        </div>
                    </div>
                    <div>
                        <div className="text-xs uppercase text-[#17212B]/50 font-semibold tracking-wider">Support phone</div>
                        <div className="mt-1 text-[#17212B]">
                            <a href="tel:+917722090290" className="text-[#0F766E] font-semibold text-lg" data-testid="legal-support-phone">
                                +91 7722090290
                            </a>
                        </div>
                        <div className="text-xs uppercase text-[#17212B]/50 font-semibold tracking-wider mt-4">Payments</div>
                        <div className="mt-1 text-[#17212B]/80 text-sm">
                            Processed via Cashfree Payments India Pvt. Ltd. (India-registered payment aggregator).
                        </div>
                    </div>
                </div>
            </div>

            <h2 id="channels">Contact channels</h2>
            <ul>
                <li><strong>General support &amp; refunds</strong>: call <a href="tel:+917722090290">+91 7722090290</a> during office hours.</li>
                <li><strong>Written correspondence</strong>: registered address above (subject line: &ldquo;Doctor Digital Identity Platform&rdquo;).</li>
                <li><strong>Signed-in doctors</strong>: use the in-app <em>Support</em> menu (&#47;doctor&#47;support) — tickets are tracked with a reference ID.</li>
            </ul>

            <h2 id="grievance">Grievance / disputes</h2>
            <p>
                For payment disputes, refund escalations, or data / privacy
                requests, please write to the registered address with the
                subject line <em>&ldquo;Grievance &mdash; &lt;your registered
                email&gt;&rdquo;</em> or call the support number. We aim to
                acknowledge within 3 business days and resolve within 15
                business days of receipt.
            </p>

            <h2 id="office-hours">Office hours</h2>
            <p>
                Monday to Saturday, 10:00 &ndash; 18:00 IST (excluding Indian
                public holidays). Payments and system notifications are
                processed automatically outside these hours.
            </p>
        </LegalLayout>
    );
}
